<template>
  <div class="page">
    <div style="width: 80px;height: 80px;margin-left: auto;margin-right: auto;margin-top: 50px;">
      <img style="width: 100%;height: 100%;" src="https://paiqian-file.weirenjob.com/app/icon.png" alt="">
    </div>
    <div>卫人派遣正式版</div>
    <div>
      <div style="margin-top: 40px;">
        <div>安卓系统下载地址</div>
        <a href="https://paiqian-file.weirenjob.com/app/app.apk" target="_blank">点击下载</a>
      </div>
      <div style="margin-top: 40px;">
        <div>苹果系统下载地址</div>
        <a href="https://apps.apple.com/us/app/id1508941188" target="_blank">点击下载</a>
      </div>
    </div>
    <div style="position: fixed;bottom: 10px;width: 100%;">
      <img style="width: 80px;height: 80px;" src="https://paiqian-file.weirenjob.com/app/qr_code.png" alt="">
      <div style="color: #f00;">请在手机浏览器中打开本页面</div>
    </div>
  </div>
</template>
<style>
html, body, #app {
  height: 100%;
  min-height: 100%;
  background: #1989fa03;
}

.page {
  text-align: center;
}
</style>

<script>
// const callLib = new CallApp({
//   scheme: {
//     protocol: 'weiren',
//     host: 'com.weiren.paiqian.client'
//   },
//   intent: {
//     package: 'com.weiren.paiqian.client',
//     scheme: 'weiren',
//   },
//   universal: {
//     host: 'com.weiren.paiqian.client',
//     pathKey: '',
//   },
//   appstore: 'https://apps.apple.com/us/app/id1508941188',
//   logFunc: function (status) {
//     console.info('启动' + status)
//   },
//   yingyongbao: '',
//   fallback: '',
//   timeout: 2000,
// });

export default {
  name: 'home',
  components: {},
  created() {
    console.info(this.$route)
    window.location.href = 'weiren://paiqian-client.weirenjob.com' + (this.$route.path || '')
  }
}
</script>
